export const getVideos = (state) => state.videos || [];
export const findVideoById = (state, videoId) => (getVideos(state).find(video => video.ID === videoId) || {});
